import { api, handleApiResponse, handleApiError } from '@/lib/api';
import { User } from '@/types';

export const userService = {
  async getAllUsers(): Promise<User[]> {
    try {
      const response = await api.get('/users');
      const data = handleApiResponse(response) as { users: User[] };
      return data.users; // A API retorna {users: [...]} dentro de data
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async getUserById(id: string): Promise<User> {
    try {
      const response = await api.get(`/users/${id}`);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async createUser(data: any): Promise<User> {
    try {
      const response = await api.post('/users', data);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async updateUser(id: string, data: any): Promise<User> {
    try {
      const response = await api.put(`/users/${id}`, data);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async deleteUser(id: string): Promise<void> {
    try {
      const response = await api.delete(`/users/${id}`);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async toggleUserStatus(id: string): Promise<User> {
    try {
      const response = await api.patch(`/users/${id}/toggle-status`);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },
};
